import { ClientInformationDrawerBody } from './ClientInformationDrawerBody';

export function ClientInformationDrawerBodyWrapper({ isEmpty }: { isEmpty: boolean }) {
  return <ClientInformationDrawerBody isEmpty={isEmpty} />;
}
